export const reviewPaths = {
  '10': 'superb',
  '9': 'superb',
  '8': 'veryGood',
  '7': 'good',
  other: 'pleasant',
};
